export const contactTranslations = {
    contactUs: {
      title: "Contact Us",
      description: "Have questions or need assistance? Our team is here to help you with any inquiries about our services or community.",
      form: {
        title: "Get in Touch",
        firstName: "First Name *",
        lastName: "Last Name *",
        email: "Email Address *",
        phone: "Phone Number",
        subject: "Subject *",
        message: "Message *",
        consent: "I agree to the privacy policy and consent to being contacted regarding my inquiry.",
        sendMessage: "Send Message"
      },
      contactInfo: {
        title: "Contact Information",
        email: {
          title: "Email",
          emails: ["info@qualitynexus.com", "support@qualitynexus.com"]
        },
        phone: {
          title: "Phone",
          numbers: ["+1 (555) 123-4567", "+1 (555) 987-6543"]
        },
        businessHours: {
          title: "Business Hours",
          hours: [
            "Monday - Friday: 9:00 AM - 6:00 PM (EST)",
            "Saturday & Sunday: Closed"
          ]
        }
      },
      urgentAssistance: {
        title: "Need urgent assistance?",
        description: "Our support team is available for priority requests and consultations.",
        liveChat: "Live Chat Available",
        buttonText: "Start Live Chat"
      },
      faq: {
        title: "Frequently Asked Questions",
        questions: [
          {
            question: "What testing services does Quality Nexus offer?",
            answer: "Quality Nexus offers a comprehensive range of testing services including functional testing, automation testing, performance testing, security testing, usability testing, API testing, QA consulting, test strategy design, and accessibility testing."
          },
          {
            question: "How do I join the Quality Nexus community?",
            answer: "You can join the Quality Nexus community by creating a free profile on our Community page. This allows you to participate in challenges, connect with mentors, attend events, and showcase your testing expertise."
          },
          {
            question: "Can I request a custom testing solution for my project?",
            answer: "Yes, we offer customized testing solutions tailored to your specific project requirements. Contact us with details about your project, and our team will work with you to develop a testing strategy that meets your needs."
          },
          {
            question: "How quickly can Quality Nexus start working on a new testing project?",
            answer: "Our typical onboarding process takes 1-2 weeks, depending on the project complexity. For urgent needs, we also offer expedited services. Contact us to discuss your timeline requirements."
          }
        ],
        viewAll: "View All FAQs"
      }
    }
  };
  